/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderListItem,
    DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderListItemToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsOrderListItem>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsOrderListItem>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


